export const getRandomColor = (
	firstname?: string,
	lastname?: string
): string => {
	// Concatenar firstname y lastname
	const fullName = `${firstname} ${lastname}`;

	// Función hash simple
	const hash = fullName.split('').reduce((acc, char) => {
		return char.charCodeAt(0) + ((acc << 5) - acc);
	}, 0);

	// Paleta de colores predefinida
	const colors = [
		'#F44336',
		'#E91E63',
		'#9C27B0',
		'#673AB7',
		'#3F51B5',
		'#2196F3',
		'#03A9F4',
		'#00BCD4',
		'#009688',
		'#4CAF50',
		'#8BC34A',
		'#CDDC39',
		'#FFC107',
		'#FF9800',
		'#FF5722',
	];

	// Seleccionar color basado en el hash
	const colorIndex = Math.abs(hash) % colors.length;
	return colors[colorIndex];
};
